export const environment = {
	production: true,
	isLocalServer: false,
	isDevMode: false,
	configuration: 'assets/config-prd/config.json'
};
